import { createContext, useContext } from 'react'
import type { Operator } from '../api/contracts'

export interface AuthState {
  operator: Operator | null
  deviceId: string
  isAuthenticated: boolean
  /** True when the last failure was a dead session rather than a bad password. */
  sessionExpired: boolean
  signIn: (username: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  setDeviceId: (deviceId: string) => void
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth(): AuthState {
  const context = useContext(AuthContext)

  if (context === null) {
    throw new Error('useAuth must be used inside AuthProvider')
  }

  return context
}
